import { TextBody } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';

interface BillPaymentInfoItemProps {
  title: string;
  description: string;
  sx?: SxProp;
  titleSx?: SxProp;
  descriptionSx?: SxProp;
}

export const BillPaymentInfoItem: React.FC<BillPaymentInfoItemProps> = ({ title, description, sx, titleSx, descriptionSx }) => {
  const { container, textTitle, textDescription } = styles;

  return (
    <View sx={{ ...container, ...sx }}>
      <TextBody sx={{ ...textTitle, ...titleSx }}>{title}</TextBody>
      <TextBody sx={{ ...textDescription, ...descriptionSx }}>{description}</TextBody>
    </View>
  );
};

enum StyleName {
  container = 'container',
  textTitle = 'textTitle',
  textDescription = 'textDescription'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    mb: '$3'
  },
  textTitle: {
    color: '#666666',
    lineHeight: 20,
    flex: 1
  },
  textDescription: {
    textAlign: 'right',
    lineHeight: 20,
    pl: 5
  }
};
